module.exports = __webpack_public_path__ + "static/logo-coesione-cap-rischio-d58a1fcc498dd0f6b55ad4913f9967ca.png";